const close_all_layers = () => {
    close_slider_cart();
}

const show_overlay = () => {
    $('.site_modal_overlay').fadeIn();
    disable_scrolling();
}

const hide_overlay = () => {
    $('.site_modal_overlay').fadeOut();
    enable_scrolling();
}

const disable_scrolling = () => {
    $('html').css('overflow', 'hidden');
}

const enable_scrolling = () => {
    $('html').css('overflow', 'initial');
}

const update_cart_content = () => {
    console.log('update slider cart/cart page');

    show_cart_drawer_loading();
    $.ajax({
        url: `${window.location.pathname}?section_id=cart-drawer`,
        type: 'GET'
    }).then(res => {
        const doc = new DOMParser().parseFromString(res, "text/html");
        $('#shopify-section-cart-drawer .section_holder').html($(doc).find('#shopify-section-cart-drawer .section_holder').html());
        hide_cart_drawer_loading();
    });
}

const show_cart_drawer_loading = () => {
    $('.cd_loading_overlay').css('display', 'flex');
}

const hide_cart_drawer_loading = () => {
    $('.cd_loading_overlay').hide();
}

const update_header_icon = () => {
    console.log('update header icon');

    $.ajax({
        url: `${window.location.pathname}?section_id=cart-bubble-icon`,
        type: 'GET'
    }).then(res => {
        const bubble = new DOMParser().parseFromString(res, 'text/html').querySelector('.header-cart-bubble').innerHTML;
        document.querySelectorAll('.header-cart-bubble').forEach((element) => {
            element.innerHTML = bubble;
        });
    });
}

const update_line_item = (key, quantity) => {
    show_cart_drawer_loading();
    const updates = {
        [key]: quantity
    };

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({updates, sections:['cart-drawer', 'cart-bubble-icon']})
    })
    .then(res => res.json())
    .then(res => {
        localStorage.removeItem('no_thanks_big');
        localStorage.removeItem('no_thanks_small');
        $('#shopify-section-cart-drawer .section_holder').html($(res.sections['cart-drawer']).find('.section_holder').html());

        const bubble = new DOMParser().parseFromString(res.sections['cart-bubble-icon'], 'text/html').querySelector('.header-cart-bubble').innerHTML;
        document.querySelectorAll('.header-cart-bubble').forEach((element) => {
            element.innerHTML = bubble;
        });
    })
    .finally(() => {
        hide_cart_drawer_loading();
        if(!$('#cd_cart-drawer').hasClass('slided')) {
            open_slider_cart();
        }
    })
}

/* Slide Cart js */
const removeCartItem = (element) => {
    const lineId = element.dataset.lineid;

    update_line_item(lineId, 0);
}

const decreaseCartItem = (element) => {
    const lineId = element.dataset.lineid;
    const quantity = + element.dataset.quantity;
    update_line_item(lineId, quantity - 1);
}

const increaseCartItem = (element) => {
    const lineId = element.dataset.lineid;
    const quantity = + element.dataset.quantity;

    update_line_item(lineId, quantity + 1);
}

const addUpsellProduct = (element, selector = '.cd_upsell') => {
    const variantId = $(element).closest(selector).find("select").val();
    console.log('variantId: ', variantId);
    update_line_item(variantId, 1);
}

const updateUpsellVariantImage = (element) => {
    let src = '';
    element.querySelectorAll('option').forEach(option => {
        if(option.selected) {
            src = option.dataset.src;
        }
    });

    $(element).closest('.cd_upsell').find('.cd_upsell_image').attr('src', src);
    console.log(src);
}
/* End of Slide Cart js */

window._GlobalAddToCart = (i, t, o) => {
  const updates = {
    [i]: window.foursixtyQuantityOverride || 1,
  };

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates,
      sections: ["cart-drawer", "cart-bubble-icon"],
    }),
  })
  .then((res) => res.json())
  .then((res) => {
    localStorage.removeItem("no_thanks_big");
    localStorage.removeItem("no_thanks_small");
    $("#shopify-section-cart-drawer .section_holder").html(
      $(res.sections["cart-drawer"]).find(".section_holder").html()
    );
    
    const t = res.items.find(item => item.id == i);
    const bubble = new DOMParser()
      .parseFromString(res.sections["cart-bubble-icon"], "text/html")
      .querySelector(".header-cart-bubble").innerHTML;
    document.querySelectorAll(".header-cart-bubble").forEach((element) => {
      element.innerHTML = bubble;
    });
    if (
      (FoursixtyEmbed.$.getJSON("/cart.js", function (e) {
        FoursixtyEmbed.$(".fs-buy-container")
          .html(
            o.addedNotificationTemplate({
              name: t.title,
              cart: e,
              proceedUrl: o.proceedUrl,
              translate: o.translate.bind(o),
              f: o.moneyFormat,
              price: o.getFormattedPrice(t),
              image_url: t.image,
            })
          )
          .removeClass("fs-hidden"),
          FoursixtyEmbed.$("#fs-proceed").on("click", function () {
            o.track("ProceedClicked", e.item_count, "", e.total_value / 100, {
              fs_cart_item_count: e.item_count,
              fs_cart_total_value: e.total_value / 100,
            });
          }),
          FoursixtyEmbed.$("#fs-dismiss").on("click", function () {
            o.track("ContinueClicked", t.url, void 0, void 0, void 0, {
              fs_product_url: t.url,
            }),
              o.hideBuyForm();
          }),
          window.onFoursixtyCartAdded && window.onFoursixtyCartAdded(t),
          window.onFoursixtyCartUpdated && window.onFoursixtyCartUpdated(e);
      }),
      o.shopifyCartCountId)
    ) {
      var r = FoursixtyEmbed.$(o.shopifyCartCountId);
      FoursixtyEmbed.$.getJSON("/cart.js", function (t) {
        r.html(o.shopifyCartCountTemplate.replace("{}", t.item_count));
      });
    }
  })
  .catch((e) => {
    try {
      var i =
          window.foursixtyShopifyErrorDescription instanceof
          Function
            ? window.foursixtyShopifyErrorDescription(e)
            : e.description;
      Zepto(".fs-buy-container")
        .html('<div class="fs-loading">' + i + "</div>")
        .removeClass("fs-hidden");
    } catch (t) {
      Zepto(".fs-buy-container")
        .html('<div class="fs-loading">Problem adding item.</div>')
        .removeClass("fs-hidden");
    }
    window.setTimeout(function () {
      o.hideBuyForm();
    }, 1500);
  })
  .finally(() => {
  });
};
